import {
  bigint,
  boolean,
  integer,
  jsonb,
  pgTable,
  text,
  timestamp,
  unique,
  uuid,
} from 'drizzle-orm/pg-core'

/** プロバイダー固有の認証設定 (Azure AD: clientId/tenantId/clientSecret, OIDC: issuer/clientId 等) */
export interface TenantAuthConfig {
  clientId?: string
  clientSecret?: string
  tenantId?: string // Azure AD tenant ID (プロバイダー固有、LMS内部のtenantIdとは別)
  issuer?: string // OIDC issuer URL
  [key: string]: unknown // プロバイダー固有の追加フィールドを許容
}

/** テナント固有の設定 */
export interface TenantSettings {
  [key: string]: unknown
}

export const tenants = pgTable('tenants', {
  id: uuid('id').primaryKey().defaultRandom(),
  slug: text('slug').notNull().unique(),
  name: text('name').notNull(),
  authProvider: text('auth_provider').notNull().default('azure-ad'),
  authConfig: jsonb('auth_config').$type<TenantAuthConfig>().notNull().default({}),
  isActive: boolean('is_active').notNull().default(true),
  maxUsers: integer('max_users').default(100),
  maxStorage: bigint('max_storage', { mode: 'number' }).default(10737418240),
  settings: jsonb('settings').$type<TenantSettings>().default({}),
  createdAt: timestamp('created_at').notNull().defaultNow(),
  updatedAt: timestamp('updated_at').notNull().defaultNow(),
})

export const userTenants = pgTable(
  'user_tenants',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    userId: uuid('user_id').notNull(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    role: text('role').notNull().default('student'),
    isDefault: boolean('is_default').default(false),
    joinedAt: timestamp('joined_at').notNull().defaultNow(),
  },
  (table) => ({
    userTenantUnique: unique().on(table.userId, table.tenantId),
  }),
)

export type Tenant = typeof tenants.$inferSelect
export type NewTenant = typeof tenants.$inferInsert
export type UserTenant = typeof userTenants.$inferSelect
export type NewUserTenant = typeof userTenants.$inferInsert
